import { FuelDropdown, FuelInteractiveIcon } from '@frete.com/fuel-react';
import { FuelBottomSheet, FuelFlex } from '@frete.com/fuel-station-react';
import { useContactList } from 'hooks/openSearchTrucker/useContactList';
import { useDownloadVerifiedProfile } from 'hooks/openSearchTrucker/useDownloadVerifiedProfile';
import { useKebabMenu } from 'hooks/openSearchTrucker/useKebabMenu';
import { useShareFreightModal } from 'hooks/openSearchTrucker/useShareFreightModal';
import React, { FC, useRef } from 'react';
import KebabItem from './KebabItem';
import * as Styled from './styled';

const KebabMenu: FC = () => {
  const {
    propsKebabMenu: { inverted, isKebabVisible, isMobile, onClick, onClose },
  } = useKebabMenu();
  const { propsShareFreight } = useShareFreightModal();
  const { propsContactList } = useContactList();
  const { propsDownloadVerifiedProfile } = useDownloadVerifiedProfile();

  const dropdownRef = useRef(null);

  const makeKebabContent = (
    <>
      {propsShareFreight?.showShareFreight && (
        <KebabItem
          icon="box"
          label={propsShareFreight.buttonProps.states.textContent}
          onClick={propsShareFreight.buttonProps.events.onClick}
          dropdownRef={dropdownRef}
        />
      )}
      {propsContactList?.showAddRemoveContact && (
        <>
          {propsContactList?.inContactList ? (
            <KebabItem
              icon="remove-user"
              label={propsContactList?.removeContact.states.textContent}
              onClick={propsContactList?.removeContact.events.onClick}
              isLoading={propsContactList?.removeContact.isLoading}
              dropdownRef={dropdownRef}
            />
          ) : (
            <KebabItem
              icon="add-user"
              label={propsContactList?.addContact.states.textContent}
              isLoading={propsContactList?.addContact.isLoading}
              onClick={propsContactList?.addContact.events.onClick}
              dropdownRef={dropdownRef}
            />
          )}
        </>
      )}
      <KebabItem
        icon="download"
        label={propsDownloadVerifiedProfile.states.textContent}
        onClick={propsDownloadVerifiedProfile.events.onClick}
      />
    </>
  );

  return (
    <Styled.KebabWrapper>
      {isMobile ? (
        <>
          <FuelInteractiveIcon
            data-testid="bottom-sheet-interactive-icon"
            icon="kebab-vertical"
            iconStyle="filled"
            inverted={inverted}
            onClick={onClick}
          />

          <FuelBottomSheet
            portalName="portal-search-trucker"
            isOpen={isKebabVisible}
            onClose={onClose}
            zIndex={999}
            removePortalOnDestroy={false}
            height={propsContactList?.showAddRemoveContact ? 162 : 125}
            overlayBackground={{ opacity: 0.01 }}
            customBodyMaxHeight="unset"
            isChildBottom
            hideHeader
          >
            <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km4' }}>{makeKebabContent}</FuelFlex>
          </FuelBottomSheet>
        </>
      ) : (
        <FuelDropdown data-testid="kebab-dropdown" ref={dropdownRef}>
          <FuelInteractiveIcon
            data-testid="dropdown-interactive-icon"
            slot="trigger"
            icon="kebab-vertical"
            iconStyle="filled"
            inverted={inverted}
            onClick={onClick}
          />
          <Styled.DropdownContent slot="content">{makeKebabContent}</Styled.DropdownContent>
        </FuelDropdown>
      )}
    </Styled.KebabWrapper>
  );
};

export default KebabMenu;
